import React from 'react';

/**
 * @prop {any} internalDismissCallback
 * @prop {any} dismissCallback
 * @prop {any} styleName
 * @prop {any} children
 */

class Dismissable extends React.Component {
  dismissableRef = React.createRef();

  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
    this.timer = null;
  }

  attachRef = el => {
    this.dismissableRef.current = el;
    if (this.props.innerRef) {
      this.props.innerRef.current = el;
    }
  };

  componentDidMount() {
    this.timer = setTimeout(() => {
      ['click', 'touch'].forEach(event =>
        window.addEventListener(event, this.handleClick),
      );
    });
  }

  componentWillUnmount() {
    ['click', 'touch'].forEach(event =>
      window.removeEventListener(event, this.handleClick),
    );
    window.clearTimeout(this.timer);
  }

  handleClick({ target }) {
    if (this.dismissableRef.current) {
      if (!this.dismissableRef.current.contains(target)) {
        this.props.dismissCallback();
      } else if (this.props.internalDismissCallback) {
        this.props.internalDismissCallback();
      }
    }
  }

  render() {
    const {
      styleName,
      className,
      children,
      innerRef,
      dismissCallback,
      internalDismissCallback,
      ...containerProps
    } = this.props;
    return (
      <div
        {...containerProps}
        className={styleName || className}
        ref={this.attachRef}
      >
        {children}
      </div>
    );
  }
}

export default Dismissable;
